import { render } from "./ResetPwd.vue?vue&type=template&id=36c7c4a9&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"

import "./ResetPwd.vue?vue&type=style&index=0&id=36c7c4a9&scoped=true&lang=css"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c7c4a9"]])

export default __exports__